import Int64LookupResourceModel from '../../generated/types/model/resource/Int64LookupResourceModel';

export default class Int64LookupResourceViewModel extends Int64LookupResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
